import { MOCK_MODE } from '../../config'

/** Persistent banner shown whenever the app serves synthetic fixtures. */
export function MockBanner() {
  if (!MOCK_MODE) return null
  return (
    <div
      role="status"
      className="sticky top-0 z-[60] border-b border-crt-orange bg-crt-orange/15 px-4 py-1.5 text-center text-[11px] uppercase tracking-[0.3em] text-crt-orange"
    >
      MOCK DATA — synthetic fixtures for local development. Not market data.
      Not on-chain state.
    </div>
  )
}
